import { addDays, format, isValid, parseISO } from "date-fns";

import type { ByRestaurantId } from "../model/types";
import type { NonEmptyArray } from "../types";
import { isDiscountAvailabilityDateKey } from "../utils/discountAvailability";

const DATE_FORMAT = "yyyy-MM-dd";

const getLast = <T>(array: T[]): T | undefined => array[array.length - 1];

const isNonEmpty = <A>(array: readonly A[]): array is NonEmptyArray<A> =>
  array.length > 0;

export function getDatesForRestaurantDiscountFetch(
  restaurantId: number,
  datesById: ByRestaurantId<NonEmptyArray<string>>,
): string[] {
  const datesToShow = datesById[restaurantId] ?? [];
  if (!isNonEmpty(datesToShow)) {
    return [];
  }

  const validBase = datesToShow.filter(isDiscountAvailabilityDateKey);
  const lastDateToShow = getLast(validBase);
  const lastParsed =
    lastDateToShow != null && lastDateToShow !== ""
      ? parseISO(lastDateToShow)
      : null;

  if (!lastParsed || !isValid(lastParsed)) {
    return validBase;
  }

  const nextDate = format(addDays(lastParsed, 1), DATE_FORMAT);
  return [...validBase, nextDate];
}
